import script from "./StudyReport2023.vue?vue&type=script&setup=true&lang=js"
export * from "./StudyReport2023.vue?vue&type=script&setup=true&lang=js"

import "./StudyReport2023.vue?vue&type=style&index=0&id=60fb868f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60fb868f"]])

export default __exports__